import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-download-icon',
  template: `
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66602 12.667L3.66602 7.66699L5.06602 6.21699L7.66602 8.81699L7.66602 0.666992L9.66602 0.666992V8.81699L12.266 6.21699L13.666 7.66699L8.66602 12.667ZM2.66602 16.667C2.11602 16.667 1.64518 16.4712 1.25352 16.0795C0.861849 15.6878 0.666016 15.217 0.666016 14.667L0.666016 11.667H2.66602V14.667H14.666V11.667L16.666 11.667V14.667C16.666 15.217 16.4702 15.6878 16.0785 16.0795C15.6868 16.4712 15.216 16.667 14.666 16.667H2.66602Z"
        fill="currentColor"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadIconComponent {}
